import { Box, Typography, Button, CircularProgress, Divider } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InfoCard from './InfoCard';
import { useEffect, useState } from 'react';
import DepositBonusPopup from '../Popups/DepositBonusPopup';

// interface WireInstructions {
//     bank_name: string;
//     bank_address: string;
//     beneficiary_name: string;
//     beneficiary_address: string;
//     bank_routing_number: string;
//     bank_bsb_number: string;
//     bank_routing_swift: string;
//     bank_account_number: string;
//     payment_reference_id: string;
//     note: string;
// }
interface WireInstructions {
    dynamicData: {
        section_title: string;
        sectionData: {
            title: string;
            value: string;
        }[];
    }[];
    dynamicNote?: string;
}
interface WireInstructionsDisplayProps {
    loadingWire: boolean;
    wireInstructions: WireInstructions | null;
    wireError: string | null;
    kycData: any | null;
    setheading: (heading: string) => void;
    setSuccess: (success: boolean) => void;
    setShowPopup: (show: boolean) => void;
    setmsg: (msg: string) => void;
}

const WireInstructionsDisplay: React.FC<WireInstructionsDisplayProps> = ({
    loadingWire,
    wireInstructions,
    wireError,
    kycData,
    setheading,
    setSuccess,
    setShowPopup,
    setmsg
}) => {

    const [timeLeft, setTimeLeft] = useState("00:00:00");
    const [showBonusPopup, setShowBonusPopup] = useState(false);

    useEffect(() => {
        if (!kycData.depositBonus?.windowEndsAt) return;

        const calculateTimeLeft = () => {
            const endTime = new Date(kycData.depositBonus.windowEndsAt).getTime();
            const now = Date.now();

            const difference = endTime - now;

            if (difference <= 0) {
                setTimeLeft("00:00:00");
                return;
            }

            const hours = Math.floor(difference / (1000 * 60 * 60));
            const minutes = Math.floor(
                (difference % (1000 * 60 * 60)) / (1000 * 60)
            );
            const seconds = Math.floor(
                (difference % (1000 * 60)) / 1000
            );

            setTimeLeft(
                `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`
            );
        };

        calculateTimeLeft();

        const interval = setInterval(calculateTimeLeft, 1000);

        return () => clearInterval(interval);
    }, [kycData.depositBonus?.windowEndsAt]);

    const handleCopyError = (error: string) => {
        setheading('Error');
        setSuccess(false);
        setShowPopup(true);
        setmsg(error);
    };

    // const copyAllDetails = async () => {
    //     if (!wireInstructions) return;

    //     const text = [
    //         wireInstructions.bank_name !== '-' && `Bank: ${wireInstructions.bank_name}`,
    //         wireInstructions.bank_address !== '-' && `Bank Address: ${wireInstructions.bank_address}`,
    //         wireInstructions.beneficiary_name !== '-' && `Beneficiary: ${wireInstructions.beneficiary_name}`,
    //         wireInstructions.beneficiary_address !== '-' && `Beneficiary Address: ${wireInstructions.beneficiary_address}`,
    //         wireInstructions.bank_routing_number !== '-' && `Routing Number: ${wireInstructions.bank_routing_number}`,
    //         wireInstructions.bank_routing_swift !== '-' && `SWIFT: ${wireInstructions.bank_routing_swift}`,
    //         wireInstructions.bank_account_number !== '-' && `Account Number: ${wireInstructions.bank_account_number}`,
    //         wireInstructions.bank_bsb_number !== '-' && `BSB Number: ${wireInstructions.bank_bsb_number}`,
    //         wireInstructions.payment_reference_id !== '-' && `Reference ID: ${wireInstructions.payment_reference_id}`,
    //     ]
    //         .filter(Boolean)
    //         .join('\n');
    //     try {
    //         await navigator.clipboard.writeText(text);
    //         setheading("Copied");
    //         setSuccess(true);
    //         setShowPopup(true);
    //         setmsg(`Wire instructions copied to clipboard.`);
    //     } catch (err) {
    //         handleCopyError("Unable to copy to clipboard");
    //     }
    // };

    const copyAllDetails = async () => {
        if (!wireInstructions) return;
        const text = wireInstructions.dynamicData
            .flatMap(section =>
                section.sectionData
                    .filter(item => item.value && item.value !== '-')
                    .map(item => `${item.title}: ${item.value}`)
            )
            .join('\n');
        try {
            await navigator.clipboard.writeText(text);
            setheading("Copied");
            setSuccess(true);
            setShowPopup(true);
            setmsg(`Wire instructions copied to clipboard.`);
        } catch (err) {
            handleCopyError("Unable to copy to clipboard");
        }
    };

    if (loadingWire) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" py={6}>
                <CircularProgress color="primary" />
            </Box>
        );
    }

    if (!wireInstructions) {
        return (
            <Box
                textAlign="center"
                py={4}
                sx={{
                    color: 'rgba(255, 255, 255, 0.7)'
                }}
            >
                <Typography variant="body1">
                    {wireError ?? 'No wire instructions available.'}
                </Typography>
            </Box>
        );
    }

    return (
        <Box>
            {wireInstructions.dynamicNote && (
                <Box sx={{
                    mb: 3,
                    p: 2,
                    background: 'linear-gradient(135deg, rgba(255, 152, 0, 0.05) 0%, rgba(255, 152, 0, 0.02) 100%)',
                    borderRadius: '12px',
                    border: '1px solid rgba(255, 152, 0, 0.15)',
                    display: 'flex',
                    gap: 1.5,
                    alignItems: 'flex-start'
                }}>
                    <Typography sx={{ fontSize: '1rem' }}>📝</Typography>
                    <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.7)', lineHeight: 1.6 }}>
                        <strong style={{ color: '#FF9800' }}>Note: </strong>
                        {wireInstructions.dynamicNote}
                    </Typography>
                </Box>
            )}
            {kycData.depositBonus?.hasDeposited === false && kycData.depositBonus?.withinWindow === true && (
                <div className="deposit-reward-bar">
                    <div className="reward-coin">$</div>

                    <div className="reward-message">
                        Deposit min. ${kycData.depositBonus?.tiers?.[0]?.minAmount} within
                        <strong> {timeLeft} </strong>
                        to unlock spin rewards.
                    </div>

                    <button className="view-offer" onClick={() => setShowBonusPopup(true)}>
                        View Offer <span>›</span>
                    </button>
                </div>
            )}

            {wireInstructions.dynamicData.map((section, sIdx) => (
                <Box key={sIdx} mb={3}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            color: '#fff',
                            mb: 2,
                            fontWeight: 600,
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            fontSize: '1rem'
                        }}
                    >
                        {section.section_title === 'Bank Information' ? '🏦' : '👤'} {section.section_title}
                    </Typography>
                    <Box display="flex" flexDirection="column" gap={1.5}>
                        {section.sectionData
                            .filter(item => item.value && item.value !== '-')
                            .map((item, iIdx) => (
                                <InfoCard
                                    key={iIdx}
                                    label={item.title}
                                    value={item.value}
                                    onCopyError={handleCopyError}
                                />
                            ))}
                    </Box>
                    {sIdx < wireInstructions.dynamicData.length - 1 && (
                        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.2)', mt: 3 }} />
                    )}
                </Box>
            ))}

            <Box mt={3}>
                <Button
                    onClick={copyAllDetails}
                    variant="contained"
                    fullWidth
                    startIcon={<ContentCopyIcon />}
                    sx={{
                        py: 1.5,
                        borderRadius: 2,
                        textTransform: 'none',
                        fontSize: '1rem',
                        fontWeight: 600,
                        background: '#4A7AF2',
                        '&:hover': {
                            background: '#3461D9',
                            boxShadow: '0 4px 12px rgba(74, 122, 242, 0.4)'
                        },
                        transition: 'all 0.2s ease'
                    }}
                >
                    Copy All Details
                </Button>
            </Box>
            <DepositBonusPopup
                open={showBonusPopup}
                onClose={() => setShowBonusPopup(false)}
                onFundNow={() => setShowBonusPopup(false)}
                tiers={kycData.depositBonus?.tiers ?? []}
                hideActions
            />
        </Box>
    );
};

export default WireInstructionsDisplay;